/* ==========================================================================
   Gottikopp — native wishlist ("Önskelista"). No app, no login required.
   --------------------------------------------------------------------------
   • localStorage-backed store (key gk:wishlist:v1), newest-first.
   • <gk-wishlist-toggle> — heart button on cards & product page.
   • <gk-wishlist-page>   — full wishlist page: live-hydrated, add-to-cart,
     move-all, shareable link, import from a shared link, empty state.
   • Header badge + toast + cross-tab sync, all event driven.
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'gk:wishlist:v1';
  var SORT_KEY = 'gk:wishlist:sort';
  var EVT = 'gk:wishlist:change';
  var SHARE_PARAM = 'onskelista';

  /* ---------- store -------------------------------------------------------- */
  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function write(arr, meta) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(arr));
    } catch (e) {
      /* quota / private mode — fail quietly */
    }
    document.dispatchEvent(
      new CustomEvent(EVT, { detail: Object.assign({ items: arr }, meta || {}) })
    );
  }

  var Store = {
    all: function () {
      return read();
    },
    count: function () {
      return read().length;
    },
    has: function (id) {
      id = String(id);
      return read().some(function (it) {
        return String(it.id) === id;
      });
    },
    get: function (id) {
      id = String(id);
      return read().filter(function (it) {
        return String(it.id) === id;
      })[0];
    },
    add: function (item, silent) {
      if (!item || item.id == null) return false;
      var arr = read();
      if (arr.some(function (it) { return String(it.id) === String(item.id); })) return false;
      item.savedAt = Date.now();
      arr.unshift(item);
      write(arr, { action: 'add', item: item, silent: !!silent });
      return true;
    },
    remove: function (id, silent) {
      var before = read();
      var item = before.filter(function (it) { return String(it.id) === String(id); })[0];
      var arr = before.filter(function (it) { return String(it.id) !== String(id); });
      if (arr.length === before.length) return false;
      write(arr, { action: 'remove', item: item, silent: !!silent });
      return true;
    },
    toggle: function (item) {
      if (this.has(item.id)) {
        this.remove(item.id);
        return false;
      }
      this.add(item);
      return true;
    },
    clear: function () {
      write([], { action: 'clear' });
    }
  };

  window.GkWishlist = Store;

  /* ---------- money -------------------------------------------------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || '{{amount}} kr';
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = format.match(placeholder);
    var token = match ? match[1] : 'amount';
    switch (token) {
      case 'amount':
        value = withDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0, ' ', ',');
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(cents, 0, ' ', '');
        break;
      default:
        value = withDelimiters(cents, 2, ' ', ',');
    }
    return format.replace(placeholder, value);
  }
  Store.formatMoney = formatMoney;

  /* ---------- toast -------------------------------------------------------- */
  var toastTimer = null;
  function toast(message, opts) {
    opts = opts || {};
    var host = document.getElementById('GkWishToast');
    if (!host) {
      host = document.createElement('div');
      host.id = 'GkWishToast';
      host.className = 'gk-wish-toast';
      host.setAttribute('role', 'status');
      host.setAttribute('aria-live', 'polite');
      document.body.appendChild(host);
    }
    var action = opts.href
      ? '<a class="gk-wish-toast__link" href="' + opts.href + '">' + (opts.action || 'Visa') + '</a>'
      : '';
    host.innerHTML =
      '<span class="gk-wish-toast__icon" aria-hidden="true">' +
      (opts.icon || heartSVG(true)) +
      '</span><span class="gk-wish-toast__msg">' + message + '</span>' + action;
    host.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      host.classList.remove('is-visible');
    }, opts.duration || 3200);
  }

  /* ---------- icons -------------------------------------------------------- */
  function heartSVG(filled) {
    return (
      '<svg class="gk-heart" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M12 20.5C12 20.5 3.5 15.4 3.5 9.4C3.5 6.6 5.7 4.6 8.3 4.6C10 4.6 11.3 5.5 12 6.7C12.7 5.5 14 4.6 15.7 4.6C18.3 4.6 20.5 6.6 20.5 9.4C20.5 15.4 12 20.5 12 20.5Z"' +
      (filled ? ' fill="currentColor" stroke="currentColor"' : ' fill="none" stroke="currentColor"') +
      ' stroke-width="1.6" stroke-linejoin="round"/></svg>'
    );
  }

  /* ---------- <gk-wishlist-toggle> ---------------------------------------- */
  function GkWishlistToggle() {
    return Reflect.construct(HTMLElement, [], GkWishlistToggle);
  }
  GkWishlistToggle.prototype = Object.create(HTMLElement.prototype);
  GkWishlistToggle.prototype.constructor = GkWishlistToggle;

  GkWishlistToggle.prototype.connectedCallback = function () {
    if (this._wired) return;
    this._wired = true;
    this.button = this.querySelector('button') || this;
    this.id_ = this.dataset.id;
    this.button.addEventListener('click', this.onClick.bind(this));
    this._onChange = this.sync.bind(this);
    document.addEventListener(EVT, this._onChange);
    this.sync();
  };
  GkWishlistToggle.prototype.disconnectedCallback = function () {
    document.removeEventListener(EVT, this._onChange);
  };
  GkWishlistToggle.prototype.item = function () {
    var d = this.dataset;
    return {
      id: d.id,
      handle: d.handle,
      title: d.title,
      url: d.url,
      image: d.image || '',
      price: d.price ? parseInt(d.price, 10) : null,
      priceText: d.priceText || '',
      vendor: d.vendor || '',
      variantId: d.variantId ? parseInt(d.variantId, 10) : null,
      available: d.available !== 'false'
    };
  };
  GkWishlistToggle.prototype.onClick = function (e) {
    e.preventDefault();
    e.stopPropagation();
    var saved = Store.toggle(this.item());
    if (saved) {
      this.button.classList.add('is-bursting');
      var self = this;
      window.setTimeout(function () { self.button.classList.remove('is-bursting'); }, 650);
      toast('Sparad i önskelistan', { href: this.dataset.pageUrl || '/pages/onskelista', action: 'Visa' });
    } else {
      toast('Borttagen från önskelistan', { icon: heartSVG(false) });
    }
  };
  GkWishlistToggle.prototype.sync = function () {
    var saved = Store.has(this.id_);
    this.button.classList.toggle('is-saved', saved);
    this.button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    var label = saved ? (this.dataset.labelSaved || 'Sparad') : (this.dataset.labelDefault || 'Spara');
    this.button.setAttribute('aria-label', saved ? 'Ta bort från önskelistan' : 'Spara i önskelistan');
    var span = this.button.querySelector('.gk-wish-btn__label');
    if (span) span.textContent = label;
  };

  if (!window.customElements.get('gk-wishlist-toggle')) {
    window.customElements.define('gk-wishlist-toggle', GkWishlistToggle);
  }

  /* ---------- header badge ------------------------------------------------- */
  function syncBadges() {
    var n = Store.count();
    document.querySelectorAll('[data-gk-wishlist-count]').forEach(function (el) {
      el.textContent = n < 100 ? n : '99+';
      var bubble = el.closest('.gk-wishlist-bubble') || el;
      bubble.toggleAttribute('hidden', n === 0);
    });
  }
  document.addEventListener(EVT, syncBadges);
  document.addEventListener('DOMContentLoaded', syncBadges);
  syncBadges();

  /* ---------- cross-tab sync ---------------------------------------------- */
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) {
      document.dispatchEvent(new CustomEvent(EVT, { detail: { items: read(), action: 'storage', silent: true } }));
    }
  });

  /* ---------- add to cart helper ------------------------------------------ */
  function addToCart(variantId, trigger) {
    var cartDrawer = document.querySelector('cart-drawer');
    var body = {
      items: [{ id: variantId, quantity: 1 }]
    };
    if (cartDrawer) {
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
    }
    return fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) {
          toast(state.description || 'Kunde inte lägga i varukorgen', { icon: '' });
          return false;
        }
        if (cartDrawer && state.sections) {
          cartDrawer.renderContents(state);
        } else {
          document.dispatchEvent(new CustomEvent('gk:cart:added'));
          toast('Tillagd i varukorgen', { href: (window.routes && window.routes.cart_url) || '/cart', action: 'Till kassan', icon: '' });
        }
        return true;
      })
      .catch(function () {
        toast('Något gick fel — försök igen', { icon: '' });
        return false;
      });
  }
  Store.addToCart = addToCart;

  /* ---------- shared rendering (page + drawer) ---------------------------- */
  var REMOVE_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';

  function cardHTML(it, fmt) {
    var price = it.priceText || (it.price != null ? formatMoney(it.price, fmt) : '');
    var soldOut = it.available === false;
    var addBtn = it.variantId && !soldOut
      ? '<button type="button" class="button button--small gk-wish-card__add" data-wish-action="add" data-id="' + it.id + '" data-variant-id="' + it.variantId + '">Lägg i varukorgen</button>'
      : '<span class="gk-wish-card__soldout">' + (soldOut ? 'Slutsåld' : 'Visa produkt') + '</span>';
    var remove =
      '<button type="button" class="gk-wish-card__remove" data-wish-action="remove" data-id="' + it.id +
      '" aria-label="Ta bort ' + (it.title || '') + '">' + REMOVE_SVG + '</button>';
    var tag = soldOut ? ' <span class="gk-wish-card__tag">Slutsåld</span>' : '';

    var img = it.image
      ? '<img src="' + it.image + '" alt="" loading="lazy" width="400" height="400">'
      : '<span class="gk-wish-card__noimg" aria-hidden="true">' + heartSVG(true) + '</span>';
    return (
      '<li class="gk-wish-card' + (soldOut ? ' is-soldout' : '') + '" data-id="' + it.id + '">' + remove +
      '<a class="gk-wish-card__media" href="' + it.url + '">' + img + '</a>' +
      '<div class="gk-wish-card__body">' +
      (it.vendor ? '<p class="gk-wish-card__vendor">' + it.vendor + '</p>' : '') +
      '<a class="gk-wish-card__title" href="' + it.url + '">' + (it.title || '') + '</a>' +
      '<p class="gk-wish-card__price">' + price + tag + '</p>' +
      '<div class="gk-wish-card__actions">' + addBtn + '</div>' +
      '</div></li>'
    );
  }

  /* ---------- sorting ------------------------------------------------------ */
  function getSort() {
    try { return window.localStorage.getItem(SORT_KEY) || 'recent'; } catch (e) { return 'recent'; }
  }
  function setSort(value) {
    try { window.localStorage.setItem(SORT_KEY, value); } catch (e) {}
    document.dispatchEvent(new CustomEvent(EVT, { detail: { action: 'sort', silent: true } }));
  }
  function sortItems(items) {
    var s = getSort();
    var arr = items.slice();
    if (s === 'oldest') arr.sort(function (a, b) { return (a.savedAt || 0) - (b.savedAt || 0); });
    else if (s === 'price-asc') arr.sort(function (a, b) { return (a.price || 0) - (b.price || 0); });
    else if (s === 'price-desc') arr.sort(function (a, b) { return (b.price || 0) - (a.price || 0); });
    else if (s === 'name') arr.sort(function (a, b) { return String(a.title || '').localeCompare(String(b.title || ''), 'sv'); });
    return arr; /* 'recent' keeps storage order (newest first) */
  }

  /* ---------- sharing ------------------------------------------------------ */
  function shareUrl() {
    var handles = Store.all().map(function (it) { return it.handle; }).filter(Boolean);
    if (!handles.length) return null;
    return window.location.origin + '/pages/onskelista?' + SHARE_PARAM + '=' + encodeURIComponent(handles.join(','));
  }
  function copyText(url) {
    var done = function () { toast('Länk kopierad — dela din önskelista', { icon: '' }); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, function () { window.prompt('Kopiera länken:', url); });
    } else {
      window.prompt('Kopiera länken:', url);
    }
  }
  var SHARE_MSG = 'Kolla min önskelista hos Gottikopp';
  function doShare(kind) {
    var url = shareUrl();
    if (!url) { toast('Önskelistan är tom', { icon: '' }); return; }
    if (kind === 'copy-link') { copyText(url); return; }
    if (kind === 'share-email') {
      window.location.href = 'mailto:?subject=' + encodeURIComponent('Min önskelista hos Gottikopp') +
        '&body=' + encodeURIComponent(SHARE_MSG + ':\n' + url);
      return;
    }
    if (kind === 'share-whatsapp') {
      window.open('https://wa.me/?text=' + encodeURIComponent(SHARE_MSG + ': ' + url), '_blank', 'noopener');
      return;
    }
    /* 'share' — native sheet on mobile, else copy */
    if (navigator.share) { navigator.share({ title: 'Min önskelista', url: url }).catch(function () {}); }
    else { copyText(url); }
  }

  function renderInto(host) {
    var items = Store.all();
    var fmt = host.dataset.moneyFormat || '{{amount}} kr';
    host.querySelectorAll('[data-wish-count]').forEach(function (el) { el.textContent = items.length; });
    var total = items.reduce(function (sum, it) { return sum + (it.price || 0); }, 0);
    host.querySelectorAll('[data-wish-total]').forEach(function (el) { el.textContent = formatMoney(total, fmt); });
    var isEmpty = items.length === 0;
    var emptyEl = host.querySelector('[data-wish-empty]');
    if (emptyEl) emptyEl.toggleAttribute('hidden', !isEmpty);
    ['[data-wish-toolbar]', '[data-wish-footer]'].forEach(function (sel) {
      var el = host.querySelector(sel);
      if (el) el.toggleAttribute('hidden', isEmpty);
    });
    var grid = host.querySelector('[data-wish-grid]');
    if (!grid) return;
    grid.innerHTML = isEmpty ? '' : sortItems(items).map(function (it) { return cardHTML(it, fmt); }).join('');
  }

  function bindActions(host) {
    host.addEventListener('click', function (e) {
      var t = e.target.closest('[data-wish-action]');
      if (!t) return;
      var action = t.dataset.wishAction;
      if (action === 'remove') {
        Store.remove(t.dataset.id);
      } else if (action === 'add') {
        t.classList.add('is-loading');
        addToCart(parseInt(t.dataset.variantId, 10), t).then(function () { t.classList.remove('is-loading'); });
      } else if (action === 'add-all') {
        addAll(t);
      } else if (action === 'clear') {
        if (window.confirm('Töm hela önskelistan?')) Store.clear();
      } else if (action === 'share' || action === 'copy-link' || action === 'share-email' || action === 'share-whatsapp') {
        doShare(action);
        var menu = t.closest('details');
        if (menu) menu.open = false;
      }
    });
  }

  function addAll(trigger) {
    var items = Store.all().filter(function (it) { return it.variantId && it.available !== false; });
    if (!items.length) { toast('Inga köpbara produkter att lägga till', { icon: '' }); return; }
    trigger.classList.add('is-loading');
    var i = 0;
    function next() {
      if (i >= items.length) {
        trigger.classList.remove('is-loading');
        toast('Lade ' + items.length + ' produkter i varukorgen', { href: (window.routes && window.routes.cart_url) || '/cart', action: 'Till kassan', icon: '' });
        return;
      }
      addToCart(items[i].variantId, trigger).then(function () { i++; next(); });
    }
    next();
  }

  function maybeImportShared() {
    var params = new URLSearchParams(window.location.search);
    var shared = params.get(SHARE_PARAM);
    if (!shared) return;
    var handles = shared.split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    var existing = Store.all().map(function (it) { return it.handle; });
    var fresh = handles.filter(function (h) { return existing.indexOf(h) === -1; });
    if (!fresh.length) return;
    Promise.all(fresh.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      var added = 0;
      products.forEach(function (p) {
        if (!p) return;
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0];
        var ok = Store.add({
          id: p.id, handle: p.handle, title: p.title,
          url: p.url || ('/products/' + p.handle),
          image: p.featured_image || (p.media && p.media[0] && p.media[0].preview_image && p.media[0].preview_image.src) || '',
          price: p.price, priceText: '', vendor: p.vendor || '',
          variantId: v ? v.id : null, available: !!p.available
        }, true);
        if (ok) added++;
      });
      if (added) toast('Importerade ' + added + ' produkter till din önskelista', { icon: '' });
    });
  }

  /* Refresh price / availability / variant from the live product JSON. */
  var hydrated = false;
  function hydrate() {
    var items = Store.all();
    if (!items.length) return;
    var changed = false;
    Promise.all(items.map(function (it) {
      if (!it.handle) return Promise.resolve(null);
      return fetch('/products/' + it.handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return null;
          var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
          var next = {
            price: p.price, priceText: '', available: !!p.available,
            variantId: v ? v.id : it.variantId,
            image: it.image || p.featured_image || '',
            title: p.title || it.title, vendor: p.vendor || it.vendor
          };
          if (next.price !== it.price || next.available !== it.available || next.variantId !== it.variantId) changed = true;
          return Object.assign({}, it, next);
        })
        .catch(function () { return null; });
    })).then(function (results) {
      if (!changed) return;
      var current = Store.all();
      var byId = {};
      results.forEach(function (r) { if (r) byId[String(r.id)] = r; });
      write(current.map(function (it) { return byId[String(it.id)] || it; }), { action: 'hydrate', silent: true });
    });
  }

  /* ---------- <gk-wishlist-page> ------------------------------------------ */
  function GkWishlistPage() {
    return Reflect.construct(HTMLElement, [], GkWishlistPage);
  }
  GkWishlistPage.prototype = Object.create(HTMLElement.prototype);
  GkWishlistPage.prototype.constructor = GkWishlistPage;
  GkWishlistPage.prototype.connectedCallback = function () {
    var self = this;
    bindActions(this);
    maybeImportShared();
    this._onChange = function () { renderInto(self); };
    document.addEventListener(EVT, this._onChange);
    renderInto(this);
    if (!hydrated) { hydrated = true; hydrate(); }

    var sortSel = this.querySelector('[data-wish-sort]');
    if (sortSel) {
      sortSel.value = getSort();
      sortSel.addEventListener('change', function () { setSort(sortSel.value); });
    }

    this._onDocClick = function (e) {
      self.querySelectorAll('details.gk-wishpage__share[open]').forEach(function (d) {
        if (!d.contains(e.target)) d.open = false;
      });
    };
    document.addEventListener('click', this._onDocClick);
  };
  GkWishlistPage.prototype.disconnectedCallback = function () {
    document.removeEventListener(EVT, this._onChange);
    if (this._onDocClick) document.removeEventListener('click', this._onDocClick);
  };
  if (!window.customElements.get('gk-wishlist-page')) {
    window.customElements.define('gk-wishlist-page', GkWishlistPage);
  }
})();
